import style from "./MessageTip.module.css";

function MessageTip(props) {
	return <>{props.children}</>;
}

MessageTip.displayedName = "MessageTip";

export default MessageTip;
